<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar flat dense color="primary" dark>
            <v-toolbar-title>{{ $t('models.tempTeams') }}</v-toolbar-title>
            <v-spacer />
            <meta-button
              v-if="can('create', 'user')"
              type="new"
              @click="openDialog('create')"
            />
            <v-btn v-if="id" icon dark :loading="loading" @click="init">
              <v-icon>refresh</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0">
            <v-data-table
              :headers="headers"
              :items="items"
              disable-initial-sort
              :loading="loading"
              :rows-per-page-items="[8]"
              :pagination.sync="pagination"
              :total-items="totalItems"
            >
              <template slot="items" slot-scope="props">
                <td class="text-xs-center px-0">
                  <v-icon
                    v-if="can('edit', 'entity', props.item)"
                    color="success"
                    class="mr-1"
                    @click="openDialog('edit', props.item)"
                  >
                    edit
                  </v-icon>
                  <v-icon
                    v-if="can('delete', 'entity', props.item)"
                    color="error"
                    @click="ifDelete(props.item._id)"
                  >
                    delete
                  </v-icon>
                </td>
                <td>{{ props.item.name || '--' }}</td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-dialog v-model="dialogNewTempTeam" max-width="290">
        <v-card>
          <v-card-title class="text-h5">
            {{ $t('models.tempTeams') }}
          </v-card-title>

          <v-card-text>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-text-field
                v-model="team.name"
                :rules="nameRules"
                label="Name"
                required
              />
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <meta-button type="cancel" @click="dialogNewTempTeam = false" />
            <meta-button
              type="save"
              @click="type === 'create' ? createTeam() : editTeam(team._id)"
            />
          </v-card-actions>
        </v-card>
      </v-dialog>
      <dialog-delete
        :dialog.sync="dialogDelete"
        :loading="loading"
        @delete="_setDelete(idDelete)"
      />
    </v-layout>
  </v-container>
</template>

<script>
import vuetifyToast from 'vuetify-toast'
import { mapActions } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import { apiAxios } from '@/helpers'

export default {
  name: 'TabTempTeams',
  components: {
    DialogDelete,
  },
  props: {
    id: { type: String, required: false, default: '' },
  },
  data() {
    return {
      loading: false,
      dialogNewTempTeam: false,
      dialogDelete: false,
      type: null,
      items: [],
      pagination: {
        hasMore: false,
        page: 1,
        rowsPerPage: 10,
      },
      totalItems: 0,
      valid: true,
      team: { name: null, id: null },
      nameRules: [(v) => !!v || this.$t('error.error.required')],
    }
  },
  // created() {
  //   this.init()
  // },
  computed: {
    headers() {
      let headers = [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$tc('fields.global.name'),
          value: 'name',
          sortable: false,
        },
      ]

      return headers
    },
  },
  methods: {
    ...mapActions({
      setDelete: 'teams/delete',
    }),
    async init() {
      if (this.id) {
        this.loading = true
        let body = { entityId: this.id, active: 'all', isTmp: true }

        const { data } = await apiAxios
          .post(`teams/format?page=1&limit=10`, body)
          .finally(() => {
            this.loading = false
          })
        this.totalItems = data.paginate ? data.paginate.totalData : 0

        this.items = data.data ? data.data.team : []
      }
    },
    openDialog(type, item) {
      this.type = type
      this.dialogNewTempTeam = true
      this.team = item || { name: null, id: null }
    },
    createTeam() {
      apiAxios
        .post('/teams/create-tmp', { name: this.team.name, entityId: this.id })
        .then((response) => {
          vuetifyToast.show({
            text: response.data.message,
            color: 'success',
            timeout: 2000,
          })
        })
        .catch((error) => {
          vuetifyToast.show({
            text: error.response.data.message,
            color: 'danger',
            timeout: 2000,
          })
        })
        .finally(() => {
          this.dialogNewTempTeam = false
          this.init()
        })
    },
    editTeam(id) {
      apiAxios
        .put(`teams/${id}`, { name: this.team.name })
        .then((response) => {
          vuetifyToast.show({
            text: response.data.message,
            color: 'success',
            timeout: 2000,
          })
        })
        .catch((error) => {
          vuetifyToast.show({
            text: error.response.data.message,
            color: 'danger',
            timeout: 2000,
          })
        })
        .finally(() => {
          this.dialogNewTempTeam = false
          this.init()
        })
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(
        () => ((this.dialogDelete = false), this.init())
      )
    },
    clear() {
      this.items = []
      this.totalItems = 0
      this.pagination = {
        hasMore: false,
        page: 1,
        rowsPerPage: 10,
      }
    },
  },
  watch: {
    id() {
      this.clear()
      this.init()
    },
    pagination: {
      handler: function () {
        this.init()
      },
      deep: true,
    },
  },
  mounted() {
    this.clear()
    this.init()
  },
}
</script>
